export function prettyError(err) {
  if (!err) return "Unknown error";

  const data = err?.response?.data;

  if (typeof data === "string") return data;

  if (data && typeof data === "object") {
    const parts = [];
    for (const [k, v] of Object.entries(data)) {
      if (Array.isArray(v)) parts.push(`${k}: ${v.join(", ")}`);
      else if (typeof v === "string") parts.push(`${k}: ${v}`);
      else parts.push(`${k}: ${JSON.stringify(v)}`);
    }
    if (parts.length) return parts.join("\n");
  }

  return err?.message || "Request failed";
}